module.exports = __webpack_public_path__ + "img/3NP.6dd89df8.png";